import React, { useState } from 'react';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './WriteProjectDropdown.scss';

/**
 * Reusable Dropdown Component
 *
 * @param {string} placeholder - Text shown when no option is selected (e.g., "every project")
 * @param {Array<string>} options - List of dropdown options
 * @param {string} selected - Currently selected value
 * @param {Function} onChange - Callback when a new option is selected
 */

function WriteProjectDropdown({ placeholder = 'Select an option', options = [], selected, handleClick, handleSelected, showCross = true }) {
  const [isOpen, setIsOpen] = useState(false);

  // const dropdownRef = useRef(null);

  // Close dropdown if user clicks outside
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsOpen(false);
  //     }
  //   }
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  function handleClose(event) {
    event.stopPropagation();
    handleSelected(null);
  }

  // const handleOptionClick = option => {
  //   onChange(option);
  //   setIsOpen(false);
  // };

  return (
    <div className='write_project_dropdown'>
      {/* Dropdown label / "pill" */}
      <button type='button' className={`write_project_dropdown__toggle ${isOpen ? 'open' : ''}`} onClick={handleClick}>
        <ThemedText.H3>{selected?.name || placeholder}</ThemedText.H3>
        {selected?.name && showCross ? <ThemeLogo onClick={handleClose} icon={'cross'} /> : <ThemeLogo icon={'dropdownArrow'} />}
      </button>

      {/* Dropdown menu */}
      {/* {isOpen && (
        <div className='project_dropdown__menu'>
          {options?.length === 0 && <div className='project_dropdown__menu-item'>No project</div>}
          {options?.map(option => (
            <div key={option} className='project_dropdown__menu-item' onClick={() => handleOptionClick(option)}>
              {option?.name || option}
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
}

export default WriteProjectDropdown;
